<template>
  <pl-module-box
    title="课题组招生信息"
    class="recruitStudents">
    <div class="tip">
      <img src="~assets/images/app/logo.png" />
      <div>
        <div class="info">Recruit Info.</div>
        <div class="text">招生信息</div>
      </div>
    </div>
    <List
      :loading="loading"
      :data="data"
      :error="error">
        <template v-slot="{item, index}">
          <div class="recruitItem" :key="item.id">
            <router-link :to="`home/recruit/${item.id}`">{{index + 1}}.{{item.title}}</router-link>
          </div>
        </template>
    </List>
    <h3 class="link-title">Quick Link to:</h3>
    <FriendshipLinks 
      :loading="linksLoading"
      :data="linksData"
      :error="linksDataError"/>
  </pl-module-box>
</template>

<script>
import { List } from 'components/common';
import FriendshipLinks from './FriendshipLinks'
export default {
  components: {
    List,
    FriendshipLinks
  },
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
    data: {
      type: Array,
      default: () => [],
    },
    error: {
      type: Error,
      default: null,
    },
    linksLoading: {
      type: Boolean,
      default: false,
    },
    linksData: {
      type: Array,
      default: () => [],
    },
    linksDataError: {
      type: Error,
      default: null,
    },
  },
}
</script>

<style lang="less" scoped>
  @import url('~@/assets/styles/vars.less');
  .tip {
    display: flex;
    align-items: center;
    font-size: 32px;
    color: @color-five;
    margin-bottom: 16px;
    img {
      width: 150px;
    }
  }
  .info {
    font-family: @font-fm-head;
    white-space: nowrap;
  }
  .text {
    font-size: 30px;
    font-family: @font-fm-zh;
  }
  .recruitStudents {
    margin-top: @margin-large / 2;
    /deep/ .title {
      font-size: 20px;
      line-height: 39px;
    }
  }
  .recruitItem {
    margin-bottom: @margin-small;
    font-family: KaiTi,'Microsoft YaHei';
    a {
      color: @color-primary;
    }
    &:last-of-type {
      margin-bottom: 0;
    }
  }
  .link-title {
    font-size: 24px;
    font-weight: bold;
    color: #002060;
  }
</style>
